module.exports = __webpack_public_path__ + "static/media/Poppins-Black.0573b923.ttf";